import { useFormContext, type FieldPath } from "react-hook-form";

import Grid from "@mui/material/Grid";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

import { FormCurrencyField } from "@covertree/ui";

import { communityConfigurationCardSx } from "./communityConfigurationStyles";
import { parseNumericFormValue } from "./communitiesConfigurationForm";

import type { CommunityConfigurationFormValues } from "./communitiesConfigurationForm";

interface CurrencyFieldDefinition {
  label: string;
  name: FieldPath<CommunityConfigurationFormValues>;
  required: boolean;
}

const fields: CurrencyFieldDefinition[] = [
  {
    label: "Price per unit",
    name: "policyDefaults.pricePerUnit",
    required: true,
  },
  {
    label: "Operator fee",
    name: "policyDefaults.operatorFee",
    required: true,
  },
  {
    label: "MGA fee",
    name: "policyDefaults.mgaFee",
    required: true,
  },
  {
    label: "Blanket rental resident liability limit",
    name: "policyDefaults.limits.blanketRentalResidentLiabilityLimit",
    required: true,
  },
  {
    label: "Premises liability limit",
    name: "policyDefaults.limits.premisesLiabilityLimit",
    required: false,
  },
  {
    label: "Animal liability limit",
    name: "policyDefaults.limits.animalLiabilityLimit",
    required: false,
  },
  {
    label: "Medical payments limit",
    name: "policyDefaults.limits.medicalPaymentsLimit",
    required: false,
  },
];

export function PolicyDefaultsSection() {
  const { control } = useFormContext<CommunityConfigurationFormValues>();

  return (
    <Stack sx={communityConfigurationCardSx} spacing={2}>
      <Typography variant="h4">Portfolio policy defaults</Typography>
      <Typography color="text.secondary">
        These values apply to every state. New business commission is 25%;
        renewal commission is 22.5%.
      </Typography>
      <Grid container spacing={2}>
        {fields.map(({ label, name, required }, index) => (
          <Grid item xs={12} md={index < 3 ? 4 : 6} key={name}>
            <FormCurrencyField
              control={control}
              id={name.replaceAll(".", "-")}
              label={label}
              name={name}
              optional={!required}
              required={required}
              valueParser={parseNumericFormValue}
            />
          </Grid>
        ))}
      </Grid>
    </Stack>
  );
}
